export const HOTEL_ADD_TO_FAVORITES = 'hotel_add_to_favorites';
